import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './ClientDetailsTableProvider';
import { ClientDetailsBody } from '@shared/api/ServiceAPI/ClientDetails';

type DateRange = [string | null, string | null];

export interface IClientDetailsTableContext {
    dateRange: DateRange;
    ClientDetailsBody: ClientDetailsBody[];
    logoLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    userType: string | null;
    clientLoading: boolean;
    setClientDetailsIdentifier: (symbol: string) => void;
    onClientViewClick: (client: any) => void;
    setCusip: (cusip: string) => void;
    setDateRange: (range: DateRange) => void;
    setUserType: (value: string) => void;
}

export const ClientDetailsTableContext = createContext<IClientDetailsTableContext>({
    dateRange: [null, null],
    ClientDetailsBody: [],
    logoLoading: false,
    paginationOptions: null,
    sortFieldName: '',
    desc: null,
    clientLoading: false,
    userType: '',
    setClientDetailsIdentifier: emptyFunc,
    onClientViewClick: emptyFunc,
    setCusip: emptyFunc,
    setDateRange: emptyFunc,
    setUserType: emptyFunc,
});
